/**
 * 어드민 데모 모드(?demo=1로 진입) 전용 mock 데이터.
 * 실제 DB에 데이터가 들어가지 않으므로, 데모 손님이 만석 어드민 UI를
 * 실제처럼 둘러볼 수 있도록 하드코딩된 샘플 4건씩 노출.
 */

import type { Waiting } from '../types/waiting';
import type { TakeoutMenu } from '../api/takeoutMenu.api';

const today = (() => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
})();

const minutesAgo = (n: number): string =>
  new Date(Date.now() - n * 60_000).toISOString();

/**
 * 데모 대기 4건:
 * 1. 매장식사 웨이팅(WAITING + DINE_IN)
 * 2. 포장 웨이팅(WAITING + TAKEOUT, 주문 포함)
 * 3. 입장완료(SEATED + DINE_IN)
 * 4. 포장완료(SEATED + TAKEOUT)
 */
export const DEMO_WAITINGS: Waiting[] = [
  {
    id: 'demo-w-1',
    storeId: 'demo',
    waitingNumber: 5,
    customerPhone: '010****1234',
    partySize: 2,
    status: 'WAITING',
    callCount: 0,
    calledAt: null,
    seatedAt: null,
    cancelledAt: null,
    waitingDate: today,
    createdAt: minutesAgo(3),
    orderType: 'DINE_IN',
    visitCount: 2,
    isReturning: true,
  },
  {
    id: 'demo-w-2',
    storeId: 'demo',
    waitingNumber: 6,
    customerPhone: '010****5678',
    partySize: 1,
    status: 'WAITING',
    callCount: 0,
    calledAt: null,
    seatedAt: null,
    cancelledAt: null,
    waitingDate: today,
    createdAt: minutesAgo(2),
    orderType: 'TAKEOUT',
    orderItems: [
      { id: 'demo-oi-1', menuName: '비빔밥', price: 8000, quantity: 1 },
      { id: 'demo-oi-2', menuName: '불고기 도시락', price: 9500, quantity: 1 },
    ],
    totalAmount: 17500,
  },
  {
    id: 'demo-w-3',
    storeId: 'demo',
    waitingNumber: 4,
    customerPhone: '010****9012',
    partySize: 4,
    status: 'SEATED',
    callCount: 1,
    calledAt: minutesAgo(8),
    seatedAt: minutesAgo(4),
    cancelledAt: null,
    waitingDate: today,
    createdAt: minutesAgo(20),
    orderType: 'DINE_IN',
  },
  {
    id: 'demo-w-4',
    storeId: 'demo',
    waitingNumber: 3,
    customerPhone: '010****3456',
    partySize: 1,
    status: 'SEATED',
    callCount: 1,
    calledAt: minutesAgo(12),
    seatedAt: minutesAgo(6),
    cancelledAt: null,
    waitingDate: today,
    createdAt: minutesAgo(25),
    orderType: 'TAKEOUT',
    orderItems: [
      { id: 'demo-oi-3', menuName: '김치찌개', price: 7500, quantity: 2 },
      { id: 'demo-oi-4', menuName: '제육덮밥', price: 8500, quantity: 1 },
    ],
    totalAmount: 23500,
  },
];

/** 데모 포장 메뉴 4건 (키오스크 데모와 동일) */
export const DEMO_MENUS: TakeoutMenu[] = [
  {
    id: 'demo-m-1',
    storeId: 'demo',
    name: '비빔밥',
    description: '신선한 나물과 고추장을 넣어 비벼 드세요.',
    category: null,
    price: 8000,
    isActive: true,
    displayOrder: 0,
    createdAt: minutesAgo(60 * 24),
    updatedAt: minutesAgo(60 * 24),
  },
  {
    id: 'demo-m-2',
    storeId: 'demo',
    name: '불고기 도시락',
    description: '달콤한 양념 불고기와 공깃밥 구성.',
    category: null,
    price: 9500,
    isActive: true,
    displayOrder: 1,
    createdAt: minutesAgo(60 * 24),
    updatedAt: minutesAgo(60 * 24),
  },
  {
    id: 'demo-m-3',
    storeId: 'demo',
    name: '김치찌개',
    description: '돼지고기와 묵은지로 진하게 끓인 찌개.',
    category: null,
    price: 7500,
    isActive: true,
    displayOrder: 2,
    createdAt: minutesAgo(60 * 24),
    updatedAt: minutesAgo(60 * 24),
  },
  {
    id: 'demo-m-4',
    storeId: 'demo',
    name: '제육덮밥',
    description: '매콤한 제육볶음을 덮밥 스타일로 제공.',
    category: null,
    price: 8500,
    isActive: true,
    displayOrder: 3,
    createdAt: minutesAgo(60 * 24),
    updatedAt: minutesAgo(60 * 24),
  },
];
